"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const hooks_1 = require("@alcumus/hooks");
const variables_1 = __importDefault(require("../../styles/variables"));
const use_debounce_1 = require("use-debounce");
const icons_1 = require("@material-ui/icons");
const useStyles = (0, core_1.makeStyles)({
    wrapper: {
        fontFamily: variables_1.default.fonts.family.heading,
        lineHeight: variables_1.default.fonts.lineHeight.regular,
        fontSize: variables_1.default.fonts.size.regular,
    },
    label: {
        fontSize: variables_1.default.fonts.size.small,
        marginBottom: variables_1.default.spacing(0.5),
    },
    tooltip: {
        marginTop: variables_1.default.spacing(1.5),
        fontSize: variables_1.default.fonts.size.small,
        lineHeight: variables_1.default.fonts.lineHeight.small,
        padding: `${variables_1.default.spacing(1)} ${variables_1.default.spacing(2)}`,
        borderRadius: variables_1.default.spacing(1),
        backgroundColor: variables_1.default.colors.surface.neutral.default,
    },
    hint: {
        marginTop: variables_1.default.spacing(0.5),
        fontSize: variables_1.default.fonts.size.small,
        lineHeight: variables_1.default.fonts.lineHeight.small,
        color: (props) => props.state === 'error'
            ? variables_1.default.colors.text.critical
            : variables_1.default.colors.text.subdued,
    },
    input: {
        height: '40px',
        fontFamily: variables_1.default.fonts.family.heading,
        fontWeight: variables_1.default.fonts.weight.regular,
        fontSize: variables_1.default.fonts.size.regular,
        padding: `${variables_1.default.spacing(1)} ${variables_1.default.spacing(1.5)}`,
        borderRadius: variables_1.default.spacing(1),
        border: '1px solid',
        borderColor: (props) => props.state === 'error'
            ? variables_1.default.colors.border.critical
            : variables_1.default.colors.border.default,
        outline: 'none',
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
        '&::placeholder': {
            color: variables_1.default.colors.text.subdued,
            fontFamily: variables_1.default.fonts.family.heading,
            fontSize: variables_1.default.fonts.size.regular,
        },
        '&:focus': {
            borderColor: (props) => props.state === 'error'
                ? variables_1.default.colors.border.critical
                : variables_1.default.colors.border.active,
        },
    },
    validInput: {
    // Todo: clarify valid input state
    // backgroundColor: styleVariables.colors.text.success,
    },
    inputAdornment: {
        position: 'absolute',
        right: '0',
        bottom: '0',
        padding: `${variables_1.default.spacing(1)} ${variables_1.default.spacing(2)} ${variables_1.default.spacing(1)} ${variables_1.default.spacing(1)}`,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    withAdornment: {
        paddingRight: '38px',
    },
    labelWrapper: {
        position: 'relative',
        width: '100%',
        display: 'block',
    },
    inputWrapper: {
        display: 'flex',
        width: '100%',
    },
    inputWithIncrementButtons: {
        borderRadius: 0,
        textAlign: 'center',
    },
    incrementButton: {
        borderRadius: variables_1.default.spacing(1),
        border: '1px solid',
        borderColor: (props) => props.state === 'error'
            ? variables_1.default.colors.border.critical
            : variables_1.default.colors.border.default,
        outline: 'none',
        background: variables_1.default.colors.surface.default,
        color: variables_1.default.colors.text.subdued,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    incrementButtonLeft: {
        borderRightWidth: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    incrementButtonRight: {
        borderLeftWidth: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    helperText: {
        color: variables_1.default.colors.text.subdued,
        fontSize: variables_1.default.fonts.size.small,
        marginTop: variables_1.default.spacing(0.5),
    },
    asterisk: { color: variables_1.default.colors.text.critical, marginLeft: '2px' },
});
function Input({ label, placeholder, tooltip, value = '', onChange, adornment, adornmentClassName, hint, state = 'default', debounceInterval, labelClassName, isValid, type, required, helperText, className, showIncrementButtons, onIncrementButtonClick, ...props }, ref) {
    const classes = useStyles({ state });
    const [innerValue, handleInnerValueChange, setInnerValue] = (0, hooks_1.useStateFromInput)(value);
    (0, react_1.useEffect)(() => {
        if (value !== innerValue) {
            setInnerValue(value);
        }
    }, [value]);
    const fireOnChange = (0, react_1.useCallback)((event) => {
        if (onChange) {
            onChange(event);
        }
    }, [onChange]);
    const debouncedHandleOnChange = (0, use_debounce_1.useDebouncedCallback)(fireOnChange, debounceInterval || 0);
    const handleOnChange = (0, react_1.useCallback)((event) => {
        event.persist();
        handleInnerValueChange(event);
        if (debounceInterval) {
            debouncedHandleOnChange(event);
        }
        else {
            fireOnChange(event);
        }
    }, [
        fireOnChange,
        handleInnerValueChange,
        debounceInterval,
        debouncedHandleOnChange,
    ]);
    let asterisk;
    if (required) {
        asterisk = (react_1.default.createElement("span", { className: classes.asterisk, "data-testid": "asterisk" }, "*"));
    }
    const showNumberIncrementButtons = type === 'number' && showIncrementButtons;
    return (react_1.default.createElement("div", { className: classes.wrapper },
        react_1.default.createElement("label", { className: classes.labelWrapper },
            label && (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.label, labelClassName) },
                label,
                asterisk)),
            react_1.default.createElement("div", { className: classes.inputWrapper },
                showNumberIncrementButtons && (react_1.default.createElement("button", { "data-testid": "decrementBtn", className: (0, clsx_1.default)(classes.incrementButton, classes.incrementButtonLeft), onClick: props.disabled
                        ? undefined
                        : () => onIncrementButtonClick && onIncrementButtonClick(-1) },
                    react_1.default.createElement(icons_1.Remove, null))),
                react_1.default.createElement("input", { className: (0, clsx_1.default)([
                        className,
                        classes.input,
                        isValid && classes.validInput,
                        adornment && classes.withAdornment,
                        showNumberIncrementButtons && classes.inputWithIncrementButtons,
                    ]), value: innerValue, placeholder: placeholder, ref: ref, onChange: handleOnChange, type: type, ...props }),
                showNumberIncrementButtons && (react_1.default.createElement("button", { "data-testid": "incrementBtn", className: (0, clsx_1.default)(classes.incrementButton, classes.incrementButtonRight), onClick: props.disabled
                        ? undefined
                        : () => onIncrementButtonClick && onIncrementButtonClick(1) },
                    react_1.default.createElement(icons_1.Add, null)))),
            adornment && (react_1.default.createElement("div", { className: (0, clsx_1.default)([classes.inputAdornment, adornmentClassName]), "data-testid": "input-adornment" }, adornment))),
        hint && (react_1.default.createElement("div", { "data-testid": "input-hint", className: classes.hint }, hint)),
        tooltip && (react_1.default.createElement("div", { "data-testid": "input-tooltip", className: classes.tooltip }, tooltip)),
        helperText && (react_1.default.createElement("div", { className: classes.helperText, "data-testid": "helperText" }, helperText))));
}
exports.default = react_1.default.forwardRef(Input);
